
define(
	'Tavano.TT_ExcludeDewaltCategory.ExcludeDewaltModule'
	, [

		'FacetsCategoryCellListView.Extension',


	]
	, function (

		FacetsCategoryCellListViewExtension


	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {

				/** @type {LayoutComponent} */
				var layout = container.getComponent('Layout');

				if (layout) {
					//FILTER CATEGORIES -------------------------------------------------------------------------------------------------------

					layout.removeToViewContextDefinition('Header.Menu.View', 'categories');

					layout.addToViewContextDefinition('Header.Menu.View', 'categories', 'array', function (context) {

						var categoriesShop = [];
						var categories = context.categories;
						var url = window.location.host;

						var shopCategories = _.find(categories, function (data) {
							return data.text == "Shop By Manufacturer";
						});

						var shopByApplication = _.find(categories, function (data) {
							return data.text == "Shop by Application";
						});

						if (shopCategories) {
							var shopArray = shopCategories.categories;
							for (var i = 0; i < shopArray.length; i++) {
								var categoryText = (shopArray[i].text).toLowerCase();
								var dewaltArray = categoryText.split(" ");
								if (dewaltArray.length == 1) {
									if (categoryText.indexOf('dewalt') !== -1) {
										shopArray[i].href = "/dewalt";
										shopArray[i].data.hashtag = "#/dewalt";
									}
								}
							}
						}

						if (shopByApplication) {
							var shopArray = shopByApplication.categories;
							for (var i = 0; i < shopArray.length; i++) {
								var categoryText = (shopArray[i].text).toLowerCase();
								if (categoryText == "tools and accessories") {
									shopArray[i].href = "/tools-accessories";
									shopArray[i].data.hashtag = "#/tools-accessories";
								} else if (categoryText == "deck, roof, and pool coatings") {
									var airVaporArray = shopArray[i].categories;
									var GEEndurisLanding = _.find(airVaporArray, function (data) {
										return (data.text).toUpperCase() == "SILICONE ROOF COATINGS";
									});
									if (GEEndurisLanding) {
										GEEndurisLanding.href = "/ge-enduris";
										GEEndurisLanding.data.hashtag = "#/ge-enduris";
									}
								}
							}
						}

						console.log("Categories: ", categories);
						return categories;
					});
					//--------------------------------------------------------------------------------------------------------------------


					layout.addToViewContextDefinition('GlobalViews.Breadcrumb.View', 'pages', 'array', function (context) {
						var breadcrumbs = context.pages;
						var dewaltBreadcrumb = _.find(breadcrumbs, function (data) {
							return (data.text).toUpperCase() == "DEWALT";
						});

						if (dewaltBreadcrumb) {
							dewaltBreadcrumb.href = "/dewalt";
						}

						var ToolsBreadcrumb = _.find(breadcrumbs, function (data) {
							return (data.text).toLowerCase() == "tools and accessories";
						});

						if (ToolsBreadcrumb) {
							ToolsBreadcrumb.href = "/tools-accessories";
						}

						return breadcrumbs;
					});



				}

			}
		};
	});
